import { useContext } from "react";
import BounceLoader from "react-spinners/BounceLoader";
import { ThemeContext } from "styled-components";

export default function StyledBounceLoader({}) {
  const themeContext = useContext(ThemeContext);

  return <BounceLoader color={themeContext?.primary} />;
}
